"use client";
import { LewkLogo } from "@/components/c-logo";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/dialog";
import { Routes_Dashboard } from "@/config/page-routes";
import { useVisitor } from "@/lib/store/visitor-store/store";
import { getVisitorID } from "@/lib/utils/global-utils";
import { useRouter } from "@/lib/utils/router-events";
import React, { useEffect, useState } from "react";

const VisitorTracker = () => {
  // Get the visitor ID from the global state if available and other functions/const
  const { visitorId, setVisitorId, usageCount, isHydrated, MAX_GENERATIONS } =
    useVisitor();

  const router = useRouter();

  const [showDialog, setShowDialog] = useState<boolean>(false);

  //Assign a new visitor ID to the global state if it's not already set
  useEffect(() => {
    const fetchVisitorID = async () => {
      if (!visitorId) {
        const newVisitorID = await getVisitorID();
        setVisitorId(newVisitorID);
      }
    };
    isHydrated && fetchVisitorID();
  }, [isHydrated]);

  // Handle showing dialog once generations are reached
  useEffect(() => {
    if (MAX_GENERATIONS && usageCount) {
      if (usageCount >= MAX_GENERATIONS) {
        setShowDialog(true);
      }
    } else {
      console.log("Missing usageCount or MAX_GENERATIONS");
    }
  }, [MAX_GENERATIONS, usageCount]);

  return (
    <Dialog open={showDialog}>
      <DialogContent>
        <DialogTitle>
          <LewkLogo />
        </DialogTitle>
        <DialogDescription className="flex flex-col gap-4 my-4">
          <p>Oops, you're out of outfit generations! Sign up for free and enjoy unlimited:</p>
          <div className="flex flex-col gap-2">
            <p>✨Outfit generations</p>
            <p>✨Photo uploads</p>
            <p>✨Wishlist collections</p>
            <p>✨Future access to premium shopping features</p>
          </div>
        </DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button
              variant={"primary"}
              size={"base"}
              onClick={() => router.replace(Routes_Dashboard.AUTH_LOGIN)}
            >
              Sign Up
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default VisitorTracker;
